import { useMemo } from 'react';
import { PositionAssetTypeEnum } from '../../../../types';
import { IconName } from '../../../Icons';
import type { FilterableProperty } from '../types';
import { getProductTypeFilterOptionLabel, getProductTypeFilterOptions } from './productTypeFilterUtils';

/**
 * Filter property definition for position asset types (`PositionAssetTypeEnum`).
 * Use for position `AssetType` filters and surfaces that compare against position asset type values.
 */
export function usePositionAssetTypesFilter({ includePredictionMarkets = false } = {}) {
  return useMemo(
    () =>
      ({
        key: 'AssetTypes',
        label: 'Product',
        icon: IconName.CubeTransparent,
        control: 'multi-select',
        options: getProductTypeFilterOptions(Object.keys(PositionAssetTypeEnum), includePredictionMarkets),
        getOptionLabel: getProductTypeFilterOptionLabel,
      }) as const satisfies FilterableProperty,
    [includePredictionMarkets]
  );
}
